import script from "./DropdownMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./DropdownMenu.vue?vue&type=script&setup=true&lang=ts"

import "./DropdownMenu.vue?vue&type=style&index=0&id=b3602e00&lang=scss"

const __exports__ = script;

export default __exports__